// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3hTke","signatureButtonsRight":"ModalSign_signatureButtonsRight__3kDra"};